import { Fields } from './tangible-fields/fields'
jQuery(document).ready(function ($) {
  Fields($)
})
